import { Grid, Input, Select, useBasisFormContext } from "basis";
import { stateOptions } from "library/sharedOptions";
import { PersonalDetailsState } from "../../reducer/types";

type ManualAddressProps = {
  countryCode: string;
};

export const ManualAddress = ({ countryCode }: ManualAddressProps) => {
  const { Field } = useBasisFormContext<PersonalDetailsState>();

  return (
    <Grid cols={1} cols-sm={8} colsGap-sm="4" rowsGap="8">
      <Grid.Item colSpan="all" colSpan-sm="all" rowSpan-sm="0">
        <Field
          label="Street Address"
          name="applicantDetails.address.streetAddress"
          as={Input}
        />
      </Grid.Item>
      {countryCode === "NZ" && (
        <>
          <Grid.Item colSpan="all" colSpan-sm="0-3" rowSpan-sm="1">
            <Field
              label="Suburb"
              name="applicantDetails.address.suburb"
              as={Input}
            />
          </Grid.Item>
          <Grid.Item colSpan="all" colSpan-sm="4-7" rowSpan-sm="1">
            <Field
              label="City"
              name="applicantDetails.address.city"
              as={Input}
            />
          </Grid.Item>
          <Grid.Item colSpan="all" colSpan-sm="0-2" rowSpan-sm="2">
            <Field
              label="Postcode"
              name="applicantDetails.address.postCode"
              as={Input}
            />
          </Grid.Item>
        </>
      )}
      {countryCode === "AU" && (
        <>
          <Grid.Item colSpan="all" colSpan-sm="0-3" rowSpan-sm="1">
            <Field
              label="Suburb"
              name="applicantDetails.address.suburb"
              as={Input}
            />
          </Grid.Item>
          <Grid.Item colSpan="all" colSpan-sm="4-7" rowSpan-sm="1">
            <Field
              label="State"
              name="applicantDetails.address.state"
              options={stateOptions}
              as={Select}
            />
          </Grid.Item>
          <Grid.Item colSpan="all" colSpan-sm="0-2" rowSpan-sm="2">
            <Field
              label="Postcode"
              name="applicantDetails.address.postCode"
              as={Input}
            />
          </Grid.Item>
        </>
      )}
    </Grid>
  );
};
